module.exports = __webpack_public_path__ + "static/media/ico_learning_center.548d74f6.png";